import React, { useState } from "react";
import TagButton from "../common/TagButton";
import Rectangle from "../../assets/Home/Rectangle.png";
import { CTAButton } from "../common/CTA";
import { useScreen } from "../../context/ScreenContext";
import plugImage from "../../assets/Home/plug.svg";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const video1 =
  "https://storage.googleapis.com/think41-web-new/assets/Home/Contact%20Center%20Solution%20(1).mp4";
const video2 =
  "https://storage.googleapis.com/think41-web-new/assets/Home/Agent%20assist.mp4";
const video3 =
  "https://storage.googleapis.com/think41-web-new/assets/Home/Dev41%20demo%20video.mp4";
const video4 =
  "https://storage.googleapis.com/think41-web-new/assets/Home/Intellidoc_new%20(1).mp4";
const video5 =
  "https://storage.googleapis.com/think41-web-new/assets/Home/Deloitte%20Booth-%20R41%20Deloitte.mp4";

const featuresData = [
  {
    title: "Contact Center Automation",
    description:
      "Outbound voice agents that talk, schedule, and resolve—without human intervention.",
    points: [
      "Handles calls, test-drive bookings & exceptions via phone.",
      "CRM-integrated, multilingual, and always-on.",
      "Delivers consistent, error-free, personalized support.",
    ],
    iframe: video1,
  },
  {
    title: "Agent Assist",
    description:
      "AI-Powered Sales Support: Real-time copilots for RMs to drive conversion, follow-ups, and compliance.",
    points: [
      "Gives contextual recommendations during calls.",
      "Auto-summarizes and generates post-call action plans.",
      "Tracks engagement, compliance, and follow-through.",
    ],
    iframe: video2,
  },
  {
    title: "Dev41",
    description:
      "Accelerating SDLC: A hosted AI platform to go from idea to shipped product—faster.",
    points: [
      "Customizable for each tech stack and project type.",
      "Speeds up requirements, code generation & testing.",
      "Supports both modern builds and brownfield modernization.",
    ],
    iframe: video3,
  },
  {
    title: "Enterprise Knowledge Search",
    description: "Chat with documents and enterprise data—structured or not.",
    points: [
      "Instant Q&A from PDFs, spreadsheets, and databases.",
      "Generates apps, checklists, and action workflows from results.",
      "Upcoming: enable multi-user collaboration and task execution.",
    ],
    iframe: video4,
  },
  {
    title: "Recruit41",
    description:
      "Automated Hiring Assistant : Automated interviews, coding assessments & screening—on autopilot.",
    points: [
      "Fully async & customizable assessments with links.",
      "Designed for hiring at scale, with no manual scheduling.",
      "Tailored to job descriptions, competencies & org style.",
    ],
    iframe: video5,
  },
];

const FeaturesSlider = ({ featuresData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % featuresData.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + featuresData.length) % featuresData.length
    );
  };

  const currentFeature = featuresData[currentIndex];

  return (
    <div
      className="flex flex-col gap-[12px] items-center rounded-2xl max-w-2xl w-full"
      id="what_we_built"
    >
      <div className="flex flex-col items-center justify-center bg-[#D8DDF2] h-[128px] w-full rounded-lg mt-[13px] px-[16px] py-[12px] gap-[6px] md:gap-0">
        <h2 className="text-black font-montserrat text-xl md:text-2xl font-medium text-center">
          {currentFeature.title}
        </h2>
        <p className="text-[#444] font-roboto text-sm md:text-base font-normal text-center">
          {currentFeature.description}
        </p>
      </div>

      <video
        src={currentFeature.iframe}
        width="100%"
        height="300"
        allow="autoplay"
        muted
        controls
        className="rounded-[4.854px] border-[2.427px] border-[#D8DDF2]"
      ></video>

      <div className="space-y-4 mb-4 w-full">
        {currentFeature.points.map((point, index) => (
          <div
            key={index}
            className="flex flex-col h-[90px] w-full p-[10px] pl-[11px] justify-center items-start rounded bg-white shadow-[inset_0_0_0_1px_#E1E5EB,0_1px_3px_0_rgba(31,34,41,0.08)]"
          >
        
            <p className="text-black font-roboto text-base font-light leading-6">
              {point}
            </p>
          </div>
        ))}
      </div>


      <div className="flex space-x-6">
        <button
          onClick={prevSlide}
          className="bg-white p-2 rounded-full shadow hover:bg-gray-100"
        >
          <IoIosArrowBack />
        </button>
        <button
          onClick={nextSlide}
          className="bg-white p-2 rounded-full shadow hover:bg-gray-100"
        >
          <IoIosArrowForward />
        </button>
      </div>
    </div>
  );
};

const FeaturesDesktop = ({ featuresData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? featuresData.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === featuresData.length - 1 ? 0 : prevIndex + 1
    );
  };

  const currentFeature = featuresData[currentIndex];

  return (
    <div className="relative w-full max-w-7xl mx-auto">
      <div className="flex flex-col xl:flex-row gap-[12px] rounded-lg overflow-hidden">
        <div className="w-full xl:w-[700px] border-2 border-gray-300 bg-gray-100 flex items-center justify-center aspect-video">
          <video
            src={currentFeature.iframe}
            width="100%"
            height="100%"
            autoPlay
            muted
            controls
            playsInline
          ></video>
        </div>

        <div className="w-full xl:w-[700px] flex flex-col gap-[22px]">
          <div className="bg-[#04336B] text-white px-4 w-full h-[150px] flex flex-col gap-[20px] justify-center rounded-lg">
            <h2 className="text-2xl font-medium font-montserrat leading-[32px]">
              {currentFeature.title}
            </h2>
            <p className="font-montserrat leading-[28px]">
              {currentFeature.description}
            </p>
          </div>

          <div className="flex-grow">
            <div className="space-y-5">
              {currentFeature.points.map((point, index) => (
                <div
                  key={index}
                  className="border border-gray-300 rounded-lg px-4 py-[18px] font-roboto font-light"
                >
                  {point}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={goToPrevious}
        className="absolute -left-20 lg:left-[-5vw] top-1/2 -translate-y-1/2 bg-white rounded-full p-3 shadow-lg z-10 cursor-pointer"
        aria-label="Previous slide"
      >
        <IoIosArrowBack className="h-6 w-6 text-[#04336B]" />
      </button>

      <button
        onClick={goToNext}
        className="absolute -right-20 lg:right-[-5vw] top-1/2 -translate-y-1/2 bg-white rounded-full p-3 shadow-lg z-10 cursor-pointer"
        aria-label="Next slide"
      >
        <IoIosArrowForward className="h-6 w-6 text-[#04336B]" />
      </button>

      <div className="flex justify-center mt-4 space-x-2">
        {featuresData.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`h-3 w-3 rounded-full ${
              index === currentIndex ? "bg-[#04336B]" : "bg-gray-300"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

const WhatWeBuilt = ({ targetRef }) => {
  const { isMobile } = useScreen();

  return (
    <section
      style={{ backgroundImage: `url(${Rectangle})` }}
      className="md:sticky md:top-16 w-full h-full pb-[20px] flex items-center justify-center md:py-[24px] bg-cover bg-no-repeat bg-center"
    >
      <div
        ref={targetRef}
        className="flex flex-col w-full md:max-w-[1440px] pt-[24px] md:pt-0 px-[20px] md:px-[120px] items-center md:items-start md:gap-[30px]"
      >
        <div className="flex flex-col gap-[36px] w-full">
          <TagButton text="What We've Built" />
          <div className="w-full flex flex-col gap-[16px]">
            <p className="font-montserrat text-[24px] md:text-[40px] font-semibold leading-[53.24px] bg-gradient-to-r from-black to-[#0060C7] bg-clip-text text-transparent w-fit">
              Our Solutions In Action
            </p>
            <p className="w-[90%] text-[#444] font-montserrat text-[16px] font-normal leading-[160%] tracking-[-0.48px] lg:mb-[30px]">
              AI workflows and agentic systems have been built to solve
              real-world enterprise problems—tested on live data, integrated
              into existing stacks, and delivered with performance in mind.
            </p>
          </div>
        </div>

        {isMobile ? (
          <FeaturesSlider featuresData={featuresData} />
        ) : (
          <FeaturesDesktop featuresData={featuresData} />
        )}
      </div>
    </section>
  );
};

export default WhatWeBuilt;
